import { render } from "./SpinnerTtt.vue?vue&type=template&id=03128462&scoped=true"
import script from "./SpinnerTtt.vue?vue&type=script&lang=js"
export * from "./SpinnerTtt.vue?vue&type=script&lang=js"

import "./SpinnerTtt.vue?vue&type=style&index=0&id=03128462&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03128462"]])

export default __exports__